import React, { FC } from 'react'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { InfowindowItem } from 'models/infowindow'
import styles from './Infowindow.module.scss'

const Title: FC<InfowindowItem> = ({ value }) => <Heading size="widget">{value}</Heading>

const Tuple: FC<InfowindowItem> = ({ alias, value }) => (
  <Text size="small" className={styles.item}>
    <Text component="span" size="small" weight="strong" className={styles.name}>
      {alias}:
    </Text>
    {value}
  </Text>
)

const InfoText: FC<InfowindowItem> = ({ value }) => (
  <Text size="small" className={styles.item}>
    {value}
  </Text>
)

const Link: FC<InfowindowItem> = ({ alias, value }) => <a href={value}>{alias}</a>

const Image: FC<InfowindowItem> = ({ alias, value }) => (
  <>
    <Text size="small" weight="strong" className={styles.name}>
      {alias}:
    </Text>
    <img src={value} alt="" />
  </>
)

const INFOWINDOW_ITEMS: { [key: string]: FC<InfowindowItem> } = {
  title: Title,
  tuple: Tuple,
  text: InfoText,
  link: Link,
  image: Image,
}

export const renderItem = (item: InfowindowItem) => {
  const Component = INFOWINDOW_ITEMS[item.type] || INFOWINDOW_ITEMS.tuple
  const { key, ...rest } = item
  return <Component key={key} {...rest} />
}
